module.exports = __webpack_public_path__ + "img/1_006.b98b57bc.jpg";